
const COUNT_TOKEN = '{count}'

export default {
  name: 'ProductListCount',
  props: {
    total: {
      type: Number,
      default: 0,
    },
    category: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    cancelable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedTotal() {
      return Number(this.total || 0).toLocaleString(this.$i18n.locale)
    },
    countSegments() {
      const text = this.$tc(
        'components.productListToolbar.resultCount',
        this.loading ? 2 : this.total || 0,
        { count: COUNT_TOKEN }
      )
      const index = text.indexOf(COUNT_TOKEN)
      if (index < 0) return [{ key: 'text', text }]

      const before = text.slice(0, index)
      const after = text.slice(index + COUNT_TOKEN.length)

      return [
        { key: 'before', text: before.replace(/ $/, '\u00a0') },
        { key: 'number', text: this.formattedTotal, class: 'plc__number' },
        { key: 'after', text: after.replace(/^ /, '\u00a0') },
      ].filter(segment => segment.text)
    },
    search() {
      return this.$route.query.q || this.$route.params.search || null
    },
    contextPath() {
      if (this.search) return 'components.productListToolbar.forQuery'
      if (this.category) return 'components.productListToolbar.inCategory'

      return null
    },
    contextName() {
      return this.search || this.category?.name || ''
    },
    cancelLabel() {
      return this.$t('components.productList.cancelSearch')
    },
  },
}
